export const FiveMinutes = 1000 * 60 * 5;
export const InitialRetryDelay = 1000;
